/** Body for querying other orders of the current order's patient. */
export interface GetPatientRelatedTreatmentsRequest {
    readonly treatmentId: string;
    readonly patientId: number;
    readonly pageIndex: number;
    readonly pageSize: number;
}
